import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"label":((_vm.$t('Tax Rate')) + " (%)"),"outlined":"","type":"number","hide-details":"auto"},model:{value:(_vm.vatValue),callback:function ($$v) {_vm.vatValue=_vm._n($$v)},expression:"vatValue"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }